//创建自定义备注输入弹窗
import React, { useState, useEffect } from 'react';
import styles from './index.module.css';

const NicknameDialog = ({ isOpen, title, initialValue, onConfirm, onCancel }) => {
  const [value, setValue] = useState('');

  useEffect(() => {
    if (isOpen) {
      setValue(initialValue || '');
    }
  }, [isOpen, initialValue]);

  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm(value.trim());
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleConfirm();
    }
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.dialog}>
        <div className={styles.header}>
          <h3>{title}</h3>
        </div>
        <div className={styles.body}>
          <input
            type="text"
            className={styles.input}
            placeholder="请输入备注昵称"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onKeyPress={handleKeyPress}
            autoFocus
          />
        </div>
        <div className={styles.buttons}>
          <button className={styles.cancelButton} onClick={onCancel}>
            取消
          </button>
          <button className={styles.confirmButton} onClick={handleConfirm}>
            确定
          </button>
        </div>
      </div>
    </div>
  );
};

export default NicknameDialog;